/* ================================
   ChooseMe – Hero Banner
================================ */

function initHeroImageZoom() {
  const heroes = document.querySelectorAll('[data-hero-zoom]');
  if (!heroes.length) return;

  heroes.forEach(hero => {
    // force browser to register initial state
    hero.offsetHeight;

    requestAnimationFrame(() => {
      hero.classList.add('is-loaded');
    });
  });
}

// Run on normal page load
document.addEventListener('DOMContentLoaded', initHeroImageZoom);

// Run again when Shopify sections reload (theme editor safety)
document.addEventListener('shopify:section:load', initHeroImageZoom);
